import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import VisaFormService from "services/VisaFormService";

let initialState = { list: [] };

export const getSmartList = createAsyncThunk(
  "allDocumentsSearch/getSmartList",
  async (body) => {
    const response = await VisaFormService.getSmartserviceList2(body);

    return response?.results;
  }
);
export const getSmartListPreApprove = createAsyncThunk(
  "allDocumentsSearch/getSmartListPreApprove",
  async (body) => {
    const response = await VisaFormService.getSmartserviceListPreApprove(body);

    return response?.results;
  }
);

const allDocumentsSearchSlice = createSlice({
  name: "allDocumentsSearch",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getSmartList, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(getSmartListPreApprove, builder, ["list"]);
  },
});

// export const { } = allDocumentsSearchSlice.actions;

export default allDocumentsSearchSlice.reducer;
